import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { arrangeColumns } from '@user/components/xGrid'
import {
  selectWorkWaveContactDuplicatesColumnOrder,
  useLoadListViewPreferencesOnce,
} from '@user/store/userPreferences'
import { GridDensity, useGridApiRef } from '@mui/x-data-grid-pro'
import { workWaveContactDuplicatesColumns } from '@user/components/Leads/AddLeadPage/FormComponents/DuplicateAlert/DuplicateDialog/WorkwaveContacts/tableColumn'
import { Duplicate } from '@user/query/useDuplicateCheck'

interface Props {
  onClickManage: (duplicate: Duplicate) => void
  densityMode?: GridDensity
  highlights?: Record<string, string>
}

export const useGetColumnData = (props: Props) => {
  const { onClickManage, densityMode, highlights } = props
  const userPrefsLoading = useLoadListViewPreferencesOnce()
  const apiRef = useGridApiRef()

  const columnOrder = useSelector(selectWorkWaveContactDuplicatesColumnOrder)
  const [columns, columnVisibility] = useMemo(
    () =>
      arrangeColumns(
        columnOrder,
        workWaveContactDuplicatesColumns({
          onClickManage,
          densityMode,
          highlights,
        }),
        [],
        [],
      ),
    [columnOrder, onClickManage, densityMode, highlights],
  )

  const loading = userPrefsLoading

  return { loading, columns, columnVisibility, apiRef }
}
